import React from 'react';
import { motion } from "framer-motion";
import Activities from "@/components/Activities";
import CertificatesCarousel from "@/components/CertificatesCarousel";

export default function Professional() {
  return (
    <main className="container mx-auto p-6">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="space-y-8"
      >
        {/* Header Section */}
        <div className="text-center space-y-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="relative inline-block"
          >
            <div className="absolute inset-0 bg-gradient-to-r from-primary/30 via-primary/10 to-transparent rounded-lg blur-lg"></div>
            <h1 className="text-4xl md:text-5xl font-bold relative z-10 px-6 py-3">
              Professional
            </h1>
          </motion.div>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-lg text-muted-foreground max-w-2xl mx-auto"
          >
            Explore my professional journey through skills, experiences, and certifications
          </motion.p>
        </div>

        <CertificatesCarousel />
        
        <Activities />
      </motion.div>
    </main>
  );
}
